<app-loadin-extra-data *ngIf="isLoading"></app-loadin-extra-data>
<div *ngIf="isLoading" class="loading-wrapper">
  <div class="loading-indicator gauge-loader">Loading...</div>
</div>
